import { updatePassword, logout, loginByLoginForm, sendAccountCsv, sendAccount, fetchAccount, fetchAccountById, receiveAccountListFile,fetchAccountByUserId, removeAccountById } from '../api/serveraccess'
import store from '@/store/index';

export default function (){

  const changePassword = async( oldPassword, newPassword, callback ) => {
    try{
      var res = await updatePassword( oldPassword, newPassword )
      console.log( res )
      if( res == "1"){
        callback("success")
      }else{
        callback("error")
      }
    }catch(e){
      callback(e)
    }
  }

  const deleteAccountById = async( id, callback ) => {
    try{
      await removeAccountById( id )
      callback("success", id)
    }catch(e){
      callback(e)
    }
  }


  const downloadAccountListFile = async( callback, progressCallback ) => {
    try{
      await receiveAccountListFile( progressCallback )
      callback("success")
    }catch(e){
      callback(e)
    }
  }

  const logoutAccount  = async( callback ) => {
    try{ 
      await logout()
      
      store.commit("setSearchCompanyName", "")
      store.commit("setSearchAccountName", "")
      store.commit("setSearchAccountId", "")
      store.commit("setIsLogin", false)
      store.commit("setRole", "")
      store.commit("setAuthToken", "")
      
      callback("success")
    }catch(e){
      callback(e)
    }
  
  }

  const loginAccount = async( loginForm, callback ) => {
    try{
      var data = await loginByLoginForm(loginForm.value)
      var datas = data.split('@')
      var result = datas[0]
      var role = ""
      if( result == "Success"){
        role = datas[1]
        
        store.commit("setIsLogin", true)
        store.commit("setRole", role)
        
      }
      callback(result, role)
    }catch(e){
      console.log(e)
      callback(e)
    }
  }

  const getAccount = async( callback ) => {
    try{
      var accountList = await fetchAccount()
      callback("success", accountList)
    }catch(e){
      console.log(e)
      callback("")
    }
  }
  

  const checkExistUserId = async(  account, callback ) =>{
    try{
      let tempAccount = await fetchAccountByUserId(account.userid)
      if( tempAccount.userid == null ){
        callback("ok")
        return
      }
      
      if( tempAccount.id == account.id ){
        callback("ok")
        return
      }
      
      callback("fault")
      
      callback("success")
    }catch(e){
      console.log( e )
      callback(e)
    }
  }
  
  const getAccountById = async( id, callback ) =>{
    try{
    console.log("getAccountById", id)
      var account = await fetchAccountById(id)
      callback("success", account)
    }catch(e){
      callback(e)
    }
  }
  
  const registAccount = async( regAccount, callback  ) => {
    try{
      var result = await sendAccount( regAccount )
      callback("success", result )
    }catch(e){
      callback(e)
    }
  }
  

  const registBatchAccount = async( file, callback, uploadProgressCallback ) =>{
    try{
      var result = await sendAccountCsv( file, uploadProgressCallback )
      callback( result )
    }catch(e){

      callback(e)
    }
  }
  
 
  //当該ライブラリが提供する変数、メソッドを宣言
  return{
    loginAccount,
    getAccount,
    getAccountById,
    registAccount,
    registBatchAccount,
    downloadAccountListFile,
    checkExistUserId,
    deleteAccountById,
    logoutAccount,
    changePassword
  }
}